import React from 'react'
import './navigationitems.css'
import NavigationItem from './navigationitem/navigationitem'

const navigationItems = (props) => ( 
    <ul className='NavigationItems'>
    <NavigationItem link='/' > Burger Builder
    </NavigationItem>
    {props.isAuthenticated ? <NavigationItem link='/orders'> Orders
    </NavigationItem>:null}
   { props.isAuthenticated ? <NavigationItem link='/logout'>Logout
    </NavigationItem>:
    <NavigationItem link='/auth'> Authenticate
    </NavigationItem>
    }
</ul>
);
export default navigationItems;